<template>
    <!-- *********************************************
    *                Top Informations                *
    ********************************************** -->
    <text-blocks-operation-info v-if="mdwResponseData" :params="operationInfoParams" />
    <!-- *********************************************
    *                    Card Block                  *
    ********************************************** -->
    <divider-generic
    style="margin-top: 24px;"
    dividerSize="medium"
    icon="credit-card"
    :applyBorder="false"
    :title="t('cards.limits.step3.cardTitle')"/>
    <!-- Card Number -->
    <text-block-generic
    :params="cardTextBlockParams"/>
    <!-- Account Number -->
    <text-block-generic
    :params="accountTextBlockParams"
    :mask="ACCOUNT_NUMBER"/>
    <!-- *********************************************
    *                Limit Info Block                *
    ********************************************** -->
    <divider-generic
    dividerSize="medium"
    icon="note"
    :title="t('cards.limits.step3.limitTitle')"/>
    <!-- Current Limit -->
    <text-block-generic :params="currentLimitBlockParams"/>
    <!-- New Limit -->
    <text-block-generic :params="newLimitBlockParams"/>
    <!-- New Limit Change Button -->
    <div class="button-block">
        <divider-generic/>
        <button-primary
        icon="credit-card"
        iconPosition="right"
        :label="t('cards.limits.newLimitButton')"
        @clicked="emit('newLimitChange')"/>
    </div>
</template>

<script setup>
import TextBlocksOperationInfo from '@/components/wrappers/OperationInfo'
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import ButtonPrimary from '@/components/generic/buttons/Primary'

/* Vue */
import { ref, computed } from 'vue'

/* Aux */
import { ACCOUNT_NUMBER } from '@/assets/constants/masks'
import { amountFormat } from '@/assets/scripts/amounts'
import { ACCOUNT_MAIN_CURRENCY } from '@/assets/constants/accounts'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapActions & mapGetters */
const { getCards, getCardLimit } = mapGetters(moduleMapper.CARDS_LIMITS)

/* props received
@cardFormData {Object} object with info for our current form
@mdwResponseData { Object } contains info about the success challenge
*/

/* Emmitters */
const emit = defineEmits(['newLimitChange'])

const props = defineProps({
    cardFormData: Object,
    mdwResponseData: Object
})

const operationInfoParams = computed(() => {
    return {
        operationId: props.mdwResponseData.data.operationId,
        operationDate: props.mdwResponseData.data.creationDate,
        errorLevel: props.mdwResponseData.errorLevel
    }
})

const cardTextBlockParams = ref({
    label: t('cards.limits.step3.cardLabel'),
    content: getCards.value.find(card => card.id === props.cardFormData.cardId).cardNumber
})

const accountTextBlockParams = ref({
    label: t('cards.limits.step3.accountLabel'),
    content: getCards.value.find(card => card.id === props.cardFormData.cardId).accountNumber
})

const currentLimitBlockParams = ref({
    label: t('cards.limits.step3.currentDailyLimit'),
    content: getCardLimit.value.limit === -1 ? t('cards.limits.step3.noLimit') : amountFormat(getCardLimit.value.limit, ACCOUNT_MAIN_CURRENCY)
})

const newLimitBlockParams = ref({
    label: t('cards.limits.step3.newDailyLimit'),
    content: props.cardFormData.newLimit === null ? t('cards.limits.step3.noLimit') : amountFormat(props.cardFormData.newLimit, ACCOUNT_MAIN_CURRENCY)
})
</script>

<style lang="scss" scoped>

.button-block {
    width: 100%;
}
</style>
